import classNames from "classnames";
import { Tag } from "~/models/list";
import { addBaseUrlToTags } from "~/utils/tags";
import { buildUrl } from "~/utils/url";
import { ItemDescription } from "~/common/list/ItemDescription";
import { ItemHeader } from "~/common/list/ItemHeader";
import { FundItemCardFooter } from "./FundItemCardFooter";

interface FundItemCardProps {
  baseUrl: string;
  ein: string;
  name: string;
  rating?: number;
  starRating: number;
  donationWeight: number;
  city?: string;
  state?: string;
  tags?: Tag[];
  description?: string;
}

export function FundItemCard({
  baseUrl,
  ein,
  name,
  rating,
  starRating,
  donationWeight,
  city,
  state,
  tags,
  description,
}: FundItemCardProps) {
  return (
    <div
      onClick={() => {
        window.location.href = buildUrl(baseUrl, `/ein/${ein}`);
      }}
      className={classNames(
        "tw:block tw:p-5 tw:my-4 tw:md:my-0",
        "tw:w-full tw:min-w-[320px] tw:max-w-[400px]",
        "tw:bg-white tw:rounded-[20px] tw:lg:rounded-3xl",
        "tw:!border tw:!border-gray-300/60 tw:!shadow-[8px_8px_16px_0_rgba(166,171,189,0.1)] tw:hover:cursor-pointer",
      )}
      aria-label="nonprofit profile page"
    >
      <div className="tw:flex tw:flex-col tw:justify-between">
        <ItemHeader
          name={name}
          city={city}
          state={state}
          tags={addBaseUrlToTags(tags, baseUrl)}
        />

        <div>
          <ItemDescription description={description} />

          <FundItemCardFooter
            rating={rating}
            starRating={starRating}
            donationWeight={donationWeight}
          />
        </div>
      </div>
    </div>
  );
}
